<template>
  <div id="content">
    <div v-show="isLoading" class="loading-wraper">
      <img
        class="loading"
        src="https://p4-ky.wsukwai.com/udata/pkg/kmovie/fontend-activity/loading.be43c23130aad283.svg"
      />
    </div>
    <div
      v-if="!showDelete"
      ref="app"
      class="app-show-box"
      :style="{ background: ' #' + modelBackgroudColor }"
    >
      <div
        class="app-background-cover"
        :style="{ background: ' #' + modelBackgroudColor }"
      ></div>
      <!-- 顶部导航栏 - 助力模式下隐藏 -->
      <div v-if="!isAssistMode" class="app-bar-msg">
        <OpenTag
          :openUrl="openUrl"
          logType="try"
          :id="id"
          :shareKey="shareKey"
          :wxShareKey="wxShareKey"
        >
          <img class="img" :src="$t('shareIcon')" />
        </OpenTag>
      </div>
      <div class="app-video-box" v-show="show">
        <TwVideo
          :data="twResources"
          :twMusic="twMusic"
          v-if="produceType === 'TW_TEMPLATE' && twResources.length > 0"
        />
        <Video
          v-else
          class="app-video"
          :width="width"
          :height="height"
          :cover="modelVideoCover"
          :source="modelVideoUrl"
        ></Video>
      </div>
      <div class="app-bottom-fixed" v-show="show">
        <div v-if="!hideUserInfo" class="app-use-msg">
          <div class="app-useinfo">
            <div class="app-headportrait">
              <OpenTag
                :openUrl="openUrl"
                logType="icon"
                :id="id"
                :shareKey="shareKey"
                :wxShareKey="wxShareKey"
              >
                <img class="img" :src="modelUserPic" />
              </OpenTag>
            </div>
            <div class="app-username">{{ modelUserName }}</div>
          </div>

          <!-- 使用量统计 - 助力模式下隐藏 -->
          <div v-if="!isAssistMode" class="app-usecount">
            <div class="title-text">{{ $t("useCount") }}</div>
            <div class="count-text">
              {{ $t("numberFormat", modelUseCount) }}
            </div>
          </div>
        </div>
        <div
          class="app-text"
          :class="{
            'is-tw': produceType === 'TW_TEMPLATE' && twResources.length > 0,
          }"
        >
          <p class="app-text-desc">
            {{ modelDesc }}
          </p>
        </div>
        
        <!-- 合剪模式按钮 -->
        <div v-if="!isAssistMode && onBtnClick" class="app-use-btn" @click="onBtnClick(id)">
          <div class="app-use-btn-text" :style="{ fontSize: btnFontSize }">{{ btnText }}</div>
        </div>
        <!-- 原始按钮 - 非助力模式 -->
        <div v-else-if="!isAssistMode" class="app-use-btn">
          <OpenTag
            :openUrl="openUrl"
            :id="id"
            logType="edit"
            :shareKey="shareKey"
            :wxShareKey="wxShareKey"
          >
            <div class="app-use-btn-text">{{ $t("toUse") }}</div>
          </OpenTag>
        </div>
        
        <!-- 助力按钮 - 助力模式 -->
        <div v-else>
          <!-- 提示条 -->
          <div class="assist-tip">
            助力成功，{{ assistRole === 'receiver' ? '对方' : '您' }}即可获得24h内限时免费使用该付费模板导出的机会
          </div>
          
          <div class="app-use-btn">
            <!-- 接收方未助力：直接点击执行助力，不跳转 -->
            <div 
              v-if="assistRole === 'receiver' && assistStatus === 'receiver_can_assist'"
              class="app-use-btn-text assist-btn-text"
              @click="handleAssistButtonClick"
            >
              {{ buttonText }}
            </div>
            
            <!-- 其他情况：使用 OpenTag 跳转快影 -->
            <OpenTag
              v-else
              :openUrl="jumpUrl"
              :id="id"
              logType="assist"
              :shareKey="assistShareKey"
              :wxShareKey="assistWxShareKey"
              @click.native="handleAssistButtonClick"
            >
              <div class="app-use-btn-text assist-btn-text">{{ buttonText }}</div>
            </OpenTag>
          </div>
        </div>
      </div>
      <div v-show="showError" class="app-exit-tip">
        <div class="exit-img"></div>
        <div class="exit-text">
          {{ modelErrorMsg }}
          <br />{{ $t("clickToView") }}
        </div>
      </div>
    </div>
    <span v-show="showDelete">
      <DeleteBlock :openUrl="openUrl" :userId="kyUserId" :id="id" />
    </span>
    
    <!-- 助力成功弹窗 -->
    <AssistSuccessDialog
      :visible="showAssistDialog"
      :role="assistRole"
      :templateName="modelName"
      :mvId="id"
      :onClose="handleCloseAssistDialog"
      :onConfirm="handleAssistDialogConfirm"
    />
  </div>
</template>

<script>
import Video from "../../components/Video.vue";
import TwVideo from "../components/TwVideo.vue";
import { getUrlParam } from "@/utils/url";
import { get, toast } from "../utils/utils";
import { wxShareConfig, isWexin } from "@/utils/wx";
import { WebpMachine } from "webp-hero";
import OpenTag from "../../components/OpenTag.vue";
import DeleteBlock from "../components/DeleteBlock.vue";
import AssistSuccessDialog from "../components/AssistSuccessDialog.vue";
import { getKuaishouGid, checkAssistStatus, executeAssist } from "../utils/assist";
import kylogger from '@ky/sdk/dist/log/kylogger';

// 支持webp 格式图片

const webpMachine = new WebpMachine();

// 归因ID
const TEMPLATE_TYPE_EVENT_ID = {
  free: '100610201712',    // 免费模板
  paid: '100610201713',    // 付费模板
};

export default {
  name: "base-share",
  components: {
    Video,
    OpenTag,
    DeleteBlock,
    TwVideo,
    AssistSuccessDialog,
  },
  data() {
    return {
      showDelete: false,
      showError: false,
      id: "",
      show: false,
      modelVideoUrl: "",
      modelName: "",
      modelDesc: "",
      modelVideoCover: "",
      width: 0,
      height: 0,
      modelUserPic: "",
      modelUserName: "",
      modelUseCount: 0,
      modelErrorMsg: "",
      modelBackgroudColor: "",
      isWexin: isWexin,
      openUrl: "",
      isLoading: true,
      pageTag: "kwaiying-template-share",
      shareKey: "MV_SHARE_H5_USE_BTN",
      wxShareKey: "MV_SHARE_H5_USE_WX_LAUNCH",
      kyUserId: "",
      hideUserInfo: false,
      produceType: "",
      twResources: [],
      twMusic: "",
      
      // 助力相关字段
      isAssistMode: false,        // 是否助力模式
      assistRole: '',             // 'sender' | 'receiver' 用户角色
      assistStatus: '',           // 助力状态
      buttonText: '',             // 按钮文案
      jumpUrl: '',                // 跳转URL
      showAssistDialog: false,    // 显示助力弹窗
      shareId: '',                // 助力ID
      gid: '',                    // 快手gid
      assistShareKey: 'ASSIST_CARD_BUTTON_CLICK',      // 助力按钮埋点key
      assistWxShareKey: 'ASSIST_CARD_WX_LAUNCH',       // 助力微信埋点key
    };
  },
  props: {
    templateId: { type: String, default: "" },
    btnText: { type: String, default: "" },
    btnFontSize: { type: String, default: "" },
    onBtnClick: { type: Function, default: null },
  },
  computed: {
    // 屏幕宽度
    screenWidth() {
      return document.body.clientWidth;
    },

    screenHeight() {
      return document.body.clientHeight;
    },
  },
  methods: {
    async pageInit() {
      this.isLoading = true;
      this.id = this.templateId || getUrlParam("id");
      let from = getUrlParam("from");
      let fromParam = from || TEMPLATE_TYPE_EVENT_ID.free;
      this.openUrl = this.id
        ? `kwaiying://mv?id=${this.id}&from=${fromParam}`
        : "kwaiying://mv";
      let kyUserId = getUrlParam("kyUserId");
      let taskId = getUrlParam("taskId");
      let share_token = getUrlParam("share_token");
      if (kyUserId && taskId) {
        this.openUrl +=
          (this.id ? "&" : "?") + `taskId=${taskId}&kyUserId=${kyUserId}`; //带上活动任务ID和发起者的快影ID
      }
      if (share_token) {
        this.openUrl += (this.openUrl.includes("?") ? "&" : "?") + `share_token=${share_token}`;
      }
      
      // 检查是否助力模式
      const shareId = getUrlParam('shareId');
      if (shareId) {
        console.log('[Assist] 检测到助力模式, shareId:', shareId);
        this.isAssistMode = true;
        this.shareId = shareId;
        
        // 异步获取gid
        this.gid = await getKuaishouGid();
        console.log('[Assist] 获取到gid:', this.gid);
      }
      
      const { result, resource = {} } = await this.getModelService(this.id);
      if (result === 1 && resource) {
        this.modelName = resource.name;
        this.modelDesc =
          resource.templateBean && resource.templateBean.description;
        this.modelVideoUrl = resource.videoUrl;
        this.modelVideoCover = resource.templateBean.coverUrl;
        this.modelUserPic = resource.user.iconUrlList[0];
        this.modelUserName = resource.user.nickName;
        this.modelUseCount = resource.templateBean.useCount;
        const { w, h } = this.computedVideoSize(resource.templateBean);
        this.width = w;
        this.height = h;
        this.show = true;
        this.produceType = resource.produceType;
        this.twResources = resource.twResources;
        this.twMusic = resource.twMusic;
        // ios兼容webpg格式图片
        if (this.modelVideoCover.indexOf("webp") !== -1) {
          this.modelVideoCover = this.modelVideoCover.indexOf("?")
            ? this.modelVideoCover + ".webp"
            : this.modelVideoCover + "?_webp_type=webp.webp";
          // 增加.webp后缀 webpMachine来识别处理
          webpMachine.polyfillDocument();
        }
        wxShareConfig(
          {
            title: this.modelName,
            desc: this.modelDesc,
            imgUrl: this.modelVideoCover,
          },
          this.pageTag
        );
        
        // 助力模式：modelName已赋值后再查询助力状态（jumpUrl需要用到modelName）
        if (this.isAssistMode) {
          await this.checkAssistStatus();
          
          // 通知 App.vue 助力角色已就绪，用于延迟 PV 上报
          this.$root.$emit('assist-role-ready', {
            role: this.assistRole,
            mvId: this.id
          });
        }
      }
      if (resource?.deleteStatus === 2) {
        // 2 表示模板删除
        this.kyUserId = resource.user?.userId;
        this.showDelete = true;
      } else if (
        resource?.deleteStatus === 1 &&
        resource.weakDeleteStatus === 2
      ) {
        // 模板弱删除
        this.hideUserInfo = true;
      } else {
        this.modelErrorMsg = this.$t("noTemplate");
        this.showError = true;
      }
      this.isLoading = false;
    },
    // 1280*720
    // 720*1280
    // 720*960
    // 目前有三种尺寸的视频，统一以视频宽度为基准等比缩放
    computedVideoSize({ width, height }) {
      let result = {};
      const CW = document.body.clientWidth;
      // 获得比值
      const per = width / CW;
      result = { w: CW, h: height / per };
      return result;
    },

    async getModelService(templateId) {
      const { data = {} } = await get(
        "/rest/n/kmovie/app/resource/getTemplateById",
        {
          templateId,
          deleteVersion: 1,
        }
      );
      return data;
    },
    
    // ============ 助力相关方法 ============
    
    /**
     * 查询助力状态
     */
    async checkAssistStatus() {
      try {
        const { data } = await checkAssistStatus(this.shareId, this.gid);
        
        // 从接口返回中获取用户角色
        this.assistRole = data.role;  // 'sender' | 'receiver'
        this.buttonText = data.buttonText;
        this.assistStatus = data.viewType;

        const templateId = getUrlParam('id');
        
        // sender_waiting / receiver_already_assisted 场景，服务端返回 kwaiying://mv，需补全 id 和 from 参数
        if (data.viewType === 'sender_waiting' || data.viewType === 'receiver_already_assisted') {
          const from = TEMPLATE_TYPE_EVENT_ID.paid;
          this.jumpUrl = templateId
            ? `${data.jumpUrl}?id=${templateId}&from=${from}`
            : `${data.jumpUrl}?from=${from}`;
        } else if (data.viewType === 'sender_success') {
          const from = TEMPLATE_TYPE_EVENT_ID.paid;
          const jumpSchema = templateId
            ? `kwaiying://mv?id=${templateId}&from=${from}`
            : `kwaiying://mv?from=${from}`;
          this.jumpUrl = data.jumpUrl + encodeURIComponent(this.modelName || '') + '&jumpSchema=' + encodeURIComponent(jumpSchema) + '&topImage=' + encodeURIComponent(this.modelVideoCover || '') + (templateId ? '&templateId=' + encodeURIComponent(templateId) : '');
        } else {
          this.jumpUrl = data.jumpUrl;
        }
        
        console.log('[Assist] 助力状态:', {
          role: this.assistRole,
          status: this.assistStatus,
          buttonText: this.buttonText
        });
        
        // 如果是发送方已助力，自动弹窗
        if (this.assistRole === 'sender' && this.assistStatus === 'sender_success') {
          this.showAssistDialog = true;
        }
      } catch (error) {
        console.error('[Assist] 查询助力状态失败:', error);
      }
    },
    
    /**
     * 执行助力
     */
    async executeAssist() {
      console.log('[Assist] 执行助力, shareId:', this.shareId, 'gid:', this.gid);

      try {
        const { data } = await executeAssist(this.shareId, this.gid);
        
        if (data.receiveStatus === 'SUCCESS') {
          console.log('[Assist] 助力成功');
          // 助力成功，显示弹窗
          this.showAssistDialog = true;
          // 刷新按钮状态
          await this.checkAssistStatus();

        } else {
          const statusMsgMap = {
            'FAIL': '不能助力自己哦',
            'LIMITED': '助力次数已达上限',
            'ASSISTED': '该模板已被助力',
          };
          const errorMsg = statusMsgMap[data.receiveStatus] || data?.msg || '助力失败，请稍后重试';
          throw new Error(errorMsg);
        }
      } catch (error) {
        console.error('[Assist] 执行助力失败:', error);
        toast(error?.message);
      }
    },
    
    /**
     * 按钮点击处理
     */
    handleAssistButtonClick() {
      console.log('[Assist] 按钮点击, role:', this.assistRole, 'status:', this.assistStatus);
      
      // 埋点：按钮点击
      this.trackAssistButtonClick();
      
      if (this.assistRole === 'receiver' && this.assistStatus === 'receiver_can_assist') {
        // 接收方未助力 → 执行助力
        this.executeAssist();
      }
      // 其他情况的跳转由 OpenTag 组件处理
    },
    
    /**
     * 关闭助力弹窗
     */
    handleCloseAssistDialog() {
      console.log('[Assist] 关闭弹窗');
      this.showAssistDialog = false;
    },
    
    /**
     * 助力弹窗确认按钮
     */
    handleAssistDialogConfirm() {
      console.log('[Assist] 弹窗确认按钮, role:', this.assistRole);
      
      // 关闭弹窗
      this.showAssistDialog = false;

      if (this.jumpUrl && this.jumpUrl.length) {
        window.location.href = this.jumpUrl;
      } else {
        // 特殊情况走默认兜底跳转逻辑
        const templateId = getUrlParam('id');
        const form = 'mv_share_ks';
        const targetUrl = templateId ? `kwaiying://mv?id=${templateId}&from=${form}` : `kwaiying://mv?from=${form}`;
        window.location.href = targetUrl;
      }
    },
    
    // ============ 埋点方法 ============
    
    /**
     * 埋点：助力按钮点击
     */
    trackAssistButtonClick() {
      kylogger.collect(
        'CLICK', 
        'MV_SHARE_H5_USE_BTN', 
        {
          btn_name: this.buttonText || '',
          id: this.id || ''
        }, 
        {
          urlPage: {
              page: 'MV_SHARE_H5',
          },
        }
      );
    },
  },
  async mounted() {
    this.pageInit();
    document.title = this.modelName;
  },
};
</script>

<style lang="less" scoped>
#content {
  text-align: center;
  background-size: cover;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
  background-color: rgba(0, 0, 0, 1);
  & > div {
    overflow: hidden;
  }
}

.app-show-box {
  width: 100%;
  max-width: 500px;
  height: 100%;
  box-sizing: border-box;
  position: relative;
}
.img {
  width: 100%;
}

//模板背景
.app-background-cover {
  top: 0;
  z-index: -1;
  position: absolute;
  width: 100%;
  height: 100%;
}
.launch-btn {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
}
// 模板页头部信息
.app-bar-msg {
  z-index: 9999;
  position: absolute;
  width: 100%;
  height: 1.1rem;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

//视频封面
.app-video-box {
  overflow: hidden;
  height: 100%;
  display: flex;
  align-items: center;
}

.app-video {
  overflow: hidden;
}

//模板页使用信息以及底部button
.app-bottom-fixed {
  width: 100%;
  padding-bottom: 0.96rem;
  position: absolute;
  overflow: hidden;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.1) 42%,
    rgba(0, 0, 0, 0.3)
  );
}

.app-use-msg {
  margin: 0rem 0.5rem;
  height: 1.28rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .app-useinfo {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .app-headportrait {
      width: 0.76rem;
      height: 0.76rem;
      border-radius: 50%;
      overflow: hidden;
      box-shadow: 0 -0.02rem #ffffff, 0.02rem 0 #ffffff, 0 0.02rem #ffffff,
        -0.02rem 0 #ffffff;
      align-items: center;
      display: flex;
    }
    .app-username {
      margin-left: 0.16rem;
      height: 0.38rem;
      font-size: 0.3rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      text-align: left;
      color: #ffffff;
      line-height: 0.38rem;
      text-shadow: 0rem 0.02rem 0.04rem 0rem rgba(0, 0, 0, 0.2);
    }
  }
  .app-usecount {
    padding: 0.13rem 0.28rem;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 0.34rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .title-text {
      margin-right: 0.16rem;
      font-size: 0.22rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      color: #ffffff;
      text-shadow: 0rem 0.02rem 0.04rem 0rem rgba(0, 0, 0, 0.2);
    }
    .count-text {
      font-size: 0.3rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      text-align: right;
      color: #ffffff;
      line-height: 0.38rem;
      text-shadow: 0rem 0.02rem 0.04rem 0rem rgba(0, 0, 0, 0.2);
    }
  }
}

.app-text {
  color: #ffffff;
  margin: 0rem 0.44rem 0.44rem 0.48rem;
  .app-text-desc {
    font-size: 0.24rem;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: justify;
    line-height: 0.36rem;
    text-shadow: 0rem 0.02rem 0.04rem 0rem rgba(0, 0, 0, 0.2);
  }
}

.is-tw {
  margin-bottom: 0.82rem;
}

.app-use-btn {
  margin: 0 auto;
  width: 5.28rem;
  height: 1.04rem;
  border-radius: 0.52rem;
  background: linear-gradient(45deg, #f52c6f, #f7365d, #ff5151);
  overflow: hidden;
  color: #fff;
  position: relative;
}

/deep/ .app-use-btn-text {
  text-align: center;
  font-size: 0.4rem;
  line-height: 1.04rem;
}

// 助力按钮文案样式
/deep/ .assist-btn-text {
  color: var(--90-ky-cs-common-text-white-1, rgba(255, 255, 255, 0.90));
  text-align: center;
  font-family: "PingFang SC";
  font-size: 0.3rem; /* 15px = 0.3rem (假设基准为50px) */
  font-style: normal;
  font-weight: 500;
  line-height: 1.04rem; /* 与按钮高度一致，实现垂直居中 */
}

// 助力提示条样式
.assist-tip {
  width: 7.28rem; /* 364px = 7.28rem */
  height: 0.56rem; /* 28px = 0.56rem */
  margin: 0 auto 0.4rem; /* 底部间距20px = 0.4rem */
  border-radius: 0.44rem; /* 22px = 0.44rem */
  border: 0.01rem solid var(--8-ky-cs-common-background-white-a-8, rgba(255, 255, 255, 0.08)); /* 0.5px = 0.01rem */
  background: var(---6ky_cs_common_background_white_a6, rgba(255, 255, 255, 0.06));
  
  color: var(--90-ky-cs-common-text-white-1, rgba(255, 255, 255, 0.90));
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: "PingFang SC";
  font-size: 0.22rem; /* 11px = 0.22rem */
  font-style: normal;
  font-weight: 400;
  line-height: 0.34rem; /* 17px = 0.34rem */
  
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.24rem;
  box-sizing: border-box;
}

.app-exit-tip {
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-size: 100%;
  .exit-img {
    width: 4.8rem;
    height: 3rem;
    background-image: url("https://p4-ky.wsukwai.com/udata/pkg/kmovie/fontend-activity/ky_empty_source.8e152a61dfc81d49.png");
    background-size: 100% 100%;
    margin-bottom: 0.18rem;
  }
  .exit-text {
    width: 4.9rem;
    font-size: 0.26rem;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: center;
    color: #666666;
    line-height: 0.4rem;
  }
}
</style>
